import React from "react";
import "./styles.scss";

const NafathCodeBanner = ({ code }) => {
  const bannerCode = code ? JSON.parse(code) : "";
  return (
    <svg
      className="nafath-code-banner-svg"
      viewBox="0 0 430 487"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1608_57030"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="57"
        width="430"
        height="430"
      >
        <circle cx="215" cy="272" r="215" fill="#18191C" />
      </mask>
      <g mask="url(#mask0_1608_57030)"></g>
      <mask
        id="mask1_1608_57030"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="-27"
        y="0"
        width="483"
        height="484"
      >
        <circle cx="214.5" cy="242" r="241.5" fill="#18191C" />
      </mask>
      <g mask="url(#mask1_1608_57030)">
        <g filter="url(#filter0_d_1608_57030)">
          <mask
            id="mask2_1608_57030"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="77"
            y="141"
            width="262"
            height="522"
          >
            <rect
              x="77.2598"
              y="141.48"
              width="261.739"
              height="520.838"
              rx="28.652"
              fill="#FFF2AF"
            />
          </mask>
          <g mask="url(#mask2_1608_57030)">
            <g filter="url(#filter1_dii_1608_57030)">
              <rect
                x="82"
                y="144"
                width="266"
                height="430"
                rx="36.7689"
                fill="white"
              />
            </g>
            <circle
              cx="208.5"
              cy="360.5"
              r="54.5"
              fill="var(--bs-primary-50)"
              stroke="var(--bs-primary-700)"
              stroke-width="4.00001"
            />
            <text
              x="208"
              y="368"
              text-anchor="middle"
              dominant-baseline="middle"
            >
              {bannerCode.value}
            </text>
          </g>
        </g>
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M264.06 198.693C264.06 195.806 262.253 193.983 259.405 193.983C256.577 193.983 254.792 195.85 254.792 198.736C254.813 201.71 256.641 203.576 259.49 203.533C262.487 203.489 264.06 201.818 264.06 198.693ZM236.278 235.142L236.278 235.142C236.45 235.169 236.582 235.189 236.713 235.189C237.844 235.189 238.977 235.19 240.11 235.192H240.11H240.11H240.111C243.513 235.196 246.921 235.2 250.318 235.167C253.017 235.146 254.569 233.692 254.654 230.957C254.782 226.399 254.782 221.842 254.782 217.284C254.782 216.437 255.015 215.96 255.781 215.569C257.278 214.812 258.749 214.018 260.222 213.223L260.223 213.223L260.223 213.223L260.223 213.223C261.029 212.788 261.835 212.353 262.647 211.923C262.885 211.792 263.14 211.677 263.451 211.537L263.451 211.537L263.603 211.467C263.612 211.591 263.624 211.701 263.636 211.803C263.652 211.952 263.667 212.086 263.667 212.227C263.667 214.085 263.676 215.942 263.686 217.8C263.708 222.258 263.73 226.716 263.625 231.174C263.518 235.905 261.627 239.79 257.439 242.243C255.292 243.501 252.911 243.957 250.488 243.957C243.664 244.001 236.862 244.001 230.038 243.957C229.108 243.946 228.179 243.835 227.249 243.725C226.436 243.628 225.622 243.532 224.809 243.501C224.111 243.475 223.413 243.566 222.71 243.656C222.236 243.717 221.76 243.779 221.28 243.805C219.303 243.892 217.305 243.957 215.328 243.979C214.529 243.982 213.73 243.986 212.932 243.989C208.14 244.01 203.348 244.032 198.556 243.957C196.898 243.935 195.176 243.697 193.582 243.219C188.756 241.7 186.163 238.162 185.334 233.192C185.164 232.129 185.121 231.044 185.121 229.959C185.111 225.348 185.111 220.738 185.111 216.127V216.122C185.111 211.51 185.111 206.899 185.1 202.287C185.1 201.506 185.291 201.072 185.993 200.724C187.433 199.989 188.857 199.229 190.28 198.47L190.28 198.47L190.28 198.47L190.28 198.47L190.281 198.47C191.168 197.996 192.054 197.523 192.944 197.056C193.127 196.956 193.318 196.865 193.556 196.752L193.557 196.752C193.679 196.694 193.813 196.631 193.964 196.557V197.881V228.895C193.964 229.698 194.007 230.523 194.113 231.326C194.432 233.735 195.729 235.124 198.088 235.167C201.45 235.228 204.801 235.214 208.157 235.201H208.157H208.157H208.158H208.158H208.159H208.159C209.598 235.195 211.038 235.189 212.479 235.189C212.529 235.189 212.585 235.167 212.665 235.136C212.723 235.114 212.794 235.086 212.883 235.059C212.83 234.949 212.777 234.84 212.725 234.733C212.573 234.417 212.426 234.113 212.267 233.822C208.866 227.788 209.822 219.671 213.755 214.897C216.093 212.032 219.133 210.469 222.747 210.144C226.424 209.818 229.953 210.339 232.972 212.77C236.245 215.396 237.925 218.912 238.456 223.079C239.009 227.224 238.265 231.065 236.16 234.646C236.158 234.654 236.155 234.663 236.152 234.673L236.143 234.709C236.123 234.785 236.091 234.907 236.011 235.102C236.111 235.116 236.198 235.129 236.277 235.142L236.278 235.142ZM230.187 224.663C230.143 224.483 230.1 224.261 230.052 224.012C229.915 223.304 229.735 222.373 229.358 221.538C228.316 219.237 226.403 218.304 223.937 218.434C221.726 218.564 220.132 219.715 219.367 221.842C217.794 226.117 219.686 231.543 223.491 233.887C224.171 234.299 224.724 234.321 225.383 233.865C228.401 231.825 230.038 228.982 230.187 224.663ZM164.79 213.356L164.791 213.355L164.791 213.354C165.363 212.36 165.936 211.363 166.513 210.356C169.383 212.114 171.934 214.132 173.975 216.736C177.822 221.598 179.14 227.197 178.503 233.339C178.354 234.837 178.035 236.356 177.525 237.767C176.249 241.37 173.528 243.475 169.915 243.648C165.428 243.858 160.942 243.861 156.449 243.864H156.449C154.427 243.865 152.404 243.867 150.379 243.887C150.358 243.887 150.315 243.865 150.209 243.8C150.242 243.717 150.271 243.627 150.301 243.535C150.349 243.389 150.399 243.239 150.464 243.106C150.903 242.242 151.347 241.378 151.791 240.512L151.792 240.512L151.792 240.512L151.792 240.512L151.792 240.512C152.575 238.987 153.361 237.459 154.12 235.922C154.418 235.336 154.758 235.119 155.417 235.119C156.727 235.136 158.036 235.126 159.345 235.116H159.346C161.31 235.1 163.274 235.084 165.238 235.162C169.086 235.314 169.83 232.97 169.745 230.171C169.596 225.049 167.172 221.294 163.027 218.581C162.793 218.386 162.517 218.19 162.156 217.952C163.032 216.412 163.909 214.888 164.79 213.356ZM171.176 198.736C171.176 201.948 169.625 203.576 166.606 203.533C163.736 203.489 161.929 201.58 161.951 198.65C161.993 195.785 163.821 193.983 166.691 193.983C169.497 194.005 171.176 195.785 171.176 198.736ZM224.446 204.43C227.528 204.43 228.953 202.932 228.974 199.742C228.974 196.747 227.38 194.989 224.552 194.967C221.555 194.945 219.791 196.66 219.791 199.633C219.791 202.672 221.491 204.43 224.446 204.43Z"
        fill="#0A9A8F"
      />
      <defs>
        <filter
          id="filter0_d_1608_57030"
          x="69.8229"
          y="139.702"
          width="365.877"
          height="538.877"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="42.2617" dy="50.1409" />
          <feGaussianBlur stdDeviation="27.2194" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1608_57030"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1608_57030"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_dii_1608_57030"
          x="63.6155"
          y="127.914"
          width="302.769"
          height="466.769"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.29806" />
          <feGaussianBlur stdDeviation="9.19223" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0666667 0 0 0 0 0.109804 0 0 0 0 0.219608 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1608_57030"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1608_57030"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-2.87257" dy="-2.87257" />
          <feGaussianBlur stdDeviation="6.89417" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.741176 0 0 0 0 0.772549 0 0 0 0 0.831373 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_1608_57030"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2.87257" dy="2.87257" />
          <feGaussianBlur stdDeviation="6.89417" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.972549 0 0 0 0 0.972549 0 0 0 0 0.964706 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_1608_57030"
            result="effect3_innerShadow_1608_57030"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default NafathCodeBanner;
